import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api/utils'
import invariant from 'tiny-invariant'

type UseJournalDetailSummary = (props: { journalId: string }) =>
  | {
      summary: {
        id: string
        customer?: {
          id: string
          name: string
          domain?: string
        }
        product?: {
          id: string
          name: string
        }
        invoice?: {
          id: string
          name: string
        }
        creditNote?: {
          id: string
          name: string
        }
        user?: {
          id: string
          name: string
        }
        narrative: string
        journalType: 'MANUAL' | 'SYSTEM'
        date: string
      }
      isLoading: false
    }
  | {
      summary: null
      isLoading: true
    }

/**
 * Data acquisition for the summary
 * @param props
 * @returns
 */
export const useJournalDetailSummary: UseJournalDetailSummary = (props: {
  journalId: string
}) => {
  const journalQuery = useQuery(
    dashboardv99990101Client.getJournal,
    { id: props.journalId },
    {
      select: res => {
        if (!res) {
          return null
        }

        return {
          id: res.id,
          customer: res.customer,
          product: res.product,
          invoice: res.invoice,
          creditNote: res.creditNote,
          narrative: res.narrative,
          journalType: res.journalType,
          user: res.user,
          date: res.date
        }
      }
    }
  )

  /**
   * We throw this error to be caught by the appropriate error boundary.
   */
  if (journalQuery.error) {
    throw new Error('Journal summary could not be loaded')
  }

  if (journalQuery.isPending) {
    return {
      isLoading: true,
      summary: null
    }
  }

  invariant(journalQuery.data, 'Journal should be defined, if loaded')

  return {
    isLoading: false,
    summary: journalQuery.data
  }
}
